// Sportpacks Redesign - (c) 2026 NextPercent, nextpercent.de
// Lizenziert ausschliesslich fuer sport-packs.myshopify.com.
// Einsatz in weiteren Shops nur mit schriftlicher Genehmigung: info@nextpercent.de
(() => {
  if (customElements.get('sp-inline-quick-add')) return;
  // Serialize cart writes so a slower response cannot replace a newer cart.
  let queue = Promise.resolve();
  let panelId = 0;
  const de = document.documentElement.lang.startsWith('de');
  const copy = de
    ? { adding: 'Wird hinzugefügt …', added: 'Im Warenkorb', error: 'Nicht hinzugefügt. Bitte erneut versuchen.', refresh: 'Im Warenkorb. Zum Warenkorb' }
    : { adding: 'Adding …', added: 'Added to bag', error: 'Not added. Please try again.', refresh: 'Added. View bag' };
  const closeLabel = de ? 'Optionen schließen' : 'Close options';
  const root = window.Shopify?.routes?.root || '/';
  customElements.define('sp-inline-quick-add', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      const opts = { signal: this.events.signal };
      this.toggle = this.querySelector('.sp-inline-quick__toggle');
      this.panel = this.querySelector('.sp-inline-quick__panel');
      this.status = this.querySelector('[role="status"]');
      this.panel.id = `sp-inline-quick-${++panelId}`;
      this.toggle.setAttribute('aria-controls', this.panel.id);
      this.openLabel = this.toggle.getAttribute('aria-label') || '';
      this.closedByOutside = 0;
      this.toggle.addEventListener('click', () => {
        // A press outside already closed the panel; the click that follows it must
        // not toggle it straight back open when the finger lands on the cross.
        if (performance.now() - this.closedByOutside < 700) { this.closedByOutside = 0; return; }
        this.setOpen(!this.hasAttribute('open'));
      }, opts);
      this.querySelectorAll('[data-variant]').forEach(button => button.addEventListener('click', () => this.add(button), opts));
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') { event.stopPropagation(); this.setOpen(false); this.toggle.focus(); }
      }, opts);
      this.addEventListener('focusout', event => {
        if (event.relatedTarget && !this.contains(event.relatedTarget)) this.closeFromOutside();
      }, opts);
      document.addEventListener('pointerdown', event => {
        if (!this.contains(event.target)) this.closeFromOutside();
      }, opts);
      this.hidden = false;
    }
    disconnectedCallback() { this.events?.abort(); clearTimeout(this.closeTimer); }
    closeFromOutside() {
      if (this.hasAttribute('open')) this.closedByOutside = performance.now();
      this.setOpen(false);
    }
    setOpen(open) {
      if (open && !this.busy) {
        clearTimeout(this.closeTimer);
        this.status.textContent = '';
        this.removeAttribute('data-feedback');
      }
      this.toggleAttribute('open', open);
      this.toggle.setAttribute('aria-expanded', String(open));
      this.toggle.setAttribute('aria-label', open ? closeLabel : this.openLabel);
      this.panel.inert = !open;
    }
    async add(button) {
      if (this.busy || button.disabled) return;
      clearTimeout(this.closeTimer);
      this.busy = true;
      this.setAttribute('aria-busy', 'true');
      this.setAttribute('data-feedback', 'pending');
      this.status.textContent = copy.adding;
      const buttons = [...this.querySelectorAll('[data-variant]:not(:disabled)')];
      buttons.forEach(item => { item.disabled = true; });
      const task = async () => {
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(button.dataset.variant), quantity: Number(button.dataset.quantity) || 1 }], sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: location.pathname }),
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : copy.error);
        // An accepted add is never retried merely because a cart section failed to render.
        this.status.textContent = button.dataset.addedLabel ? `${copy.added} · ${button.dataset.addedLabel}` : copy.added;
        this.setAttribute('data-feedback', 'success');
        try {
          const drawer = document.querySelector('cart-drawer');
          if (!drawer || !result.sections?.['cart-drawer'] || !result.sections?.['cart-icon-bubble']) throw new Error('Missing cart section');
          drawer.renderContents(result, false);
          drawer.classList.remove('is-empty');
          this.closeTimer = setTimeout(() => {
            this.setOpen(false);
            if (this.contains(document.activeElement)) this.toggle.focus();
          }, 1400);
        } catch {
          const link = document.createElement('a');
          link.href = `${root}cart`; link.textContent = copy.refresh;
          this.status.replaceChildren(link);
        }
        return result;
      };
      const pending = queue.then(task);
      queue = pending.catch(() => {});
      try { await pending; }
      catch (error) { this.setAttribute('data-feedback', 'error'); this.status.textContent = error.message || copy.error; }
      finally {
        buttons.forEach(item => { item.disabled = false; });
        this.busy = false;
        this.removeAttribute('aria-busy');
      }
    }
  });
})();
